import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ActivityType, GetActivityTypes as GetActivityTypesQuery} from 'nutshell-graphql-types';

import GET_ACTIVITY_TYPES from '../../../../core/select/queries/get-activity-types.graphql';

export function useGetActivityTypes(): {
    activityTypes: ActivityType[];
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetActivityTypesQuery, Record<any, any>>(
        GET_ACTIVITY_TYPES,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        activityTypes: data && data.activityTypes ? data.activityTypes : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
